import type { FaireProductEntity } from "../../entity_types/product";

export const p_yvq58kkft5: FaireProductEntity = {
  token: "p_yvq58kkft5",
  type: "product",
  name: "Gardener Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/59f1a784d48913f049c684873ee00d3e63d177e1b76cfaeb833439775f683b9f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6dab373dcc2b29dc58efd339338876cd9bde7fb1e777edb4e52534a160d6c38.jpeg"
  ],
  priceDollars: 3,
  description: "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:27.019Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
